export default __webpack_public_path__ + "static/media/main-promotion-mobile.14c2746e.png";